import { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cn from 'classnames';

import { sharingList } from 'actions/hearts';
import modalCSS from 'styles/components/common/modal.scss';
import css from 'styles/components/account/collectionModals/shareCollectionModal.scss';

export class ShareCollectionModal extends Component {
  static contextTypes = {
    testId: PropTypes.func
  };

  state = {
    isShareLinkLoading: true,
    shareToken: null
  };

  componentDidMount() {
    const { listId, showShareCollectionModal } = this.props;
    if (listId && showShareCollectionModal) {
      this.onShare(listId);
    }
  }

  componentDidUpdate(prevProps) {
    const { listId, showShareCollectionModal } = this.props;
    if (prevProps.showShareCollectionModal !== showShareCollectionModal && showShareCollectionModal) {
      this.onShare(listId);
    }
  }

  onCloseShareModal = () => {
    const { onDoneModal } = this.props;
    onDoneModal();
  }

  onCopyShareLink = e => {
    e.preventDefault();
    const { currentTarget: { shareLink } } = e;
    shareLink.select();
    shareLink.focus();
    document.execCommand('copy');
  }

  onShare = listId => {
    const { sharingList } = this.props;
    this.setState({ shareToken: null });
    sharingList(listId).then(({ shareToken }) => {
      this.setState({ shareToken });
    });
  }

  render() {
    const { showShareCollectionModal } = this.props;
    const { shareToken } = this.state;

    return (
      <Modal
        className={cn(modalCSS.modalContent, css.modal)}
        overlayClassName={modalCSS.modalOverlay}
        isOpen={showShareCollectionModal}>

        <div className={cn(modalCSS.header, css.header)}>
          <h2>Share</h2>
          <button
            type="button"
            className={modalCSS.close}
            onClick={this.onCloseShareModal}
            aria-label="Close"/>
        </div>

        <form method="post" className={css.shareFields} onSubmit={this.onCopyShareLink}>
          <input
            name="shareLink"
            type="url"
            aria-label="Share Link"
            placeholder="Getting link..."
            value={shareToken ? `${window?.origin}/account/favorites/${shareToken}` : '' }
            readOnly />
          <button type="submit">Copy</button>
        </form>
      </Modal>
    );
  }
}

export const mapStateToProps = () => ({});

export default connect(mapStateToProps, {
  sharingList
})(ShareCollectionModal);
